<div class="data-permission-dialog-container">
  <!-- Dialog Header -->
  <div class="dialog-header">
    <div class="header-title-container">
      <h2 class="dialog-title">Data Permissions – {{ data.functionName }}</h2>
      <button type="button" class="close-button" (click)="onCancel()" aria-label="Close">
        <span class="close-icon">&times;</span>
      </button>
    </div>
    <p class="dialog-subtitle">Configure view and edit permissions for data sections within this function.</p>
  </div>

  <!-- Dialog Content / Table -->
  <div class="dialog-content">
    <div *ngIf="isLoading" class="loading-spinner">
      <mat-spinner diameter="40"></mat-spinner>
      <span>Loading data permissions...</span>
    </div>

    <table *ngIf="!isLoading && dataSections.length > 0" class="data-permissions-table">
      <thead>
        <tr>
          <th class="col-section">Data Section</th>
          <th class="col-check">View</th>
          <th class="col-check">Edit</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let section of dataSections">
          <td class="col-section">
            <div class="section-info">
              <div class="section-icon-badge" [ngStyle]="getIconStyles(section)">
                <mat-icon>{{ getMatIcon(section) }}</mat-icon>
              </div>
              <span class="section-name">{{ section.display_name || section.section_name }}</span>
            </div>
          </td>
          <td class="col-check">
            <mat-checkbox 
              [checked]="section.can_view" 
              [disabled]="section.is_view_applicable !== 1"
              (change)="onViewChange(section, $event.checked)">
            </mat-checkbox>
          </td>
          <td class="col-check">
            <mat-checkbox 
              [checked]="section.can_edit" 
              [disabled]="!section.is_edit_applicable"
              (change)="onEditChange(section, $event.checked)">
            </mat-checkbox>
          </td>
        </tr>
      </tbody>
    </table>

    <div *ngIf="!isLoading && dataSections.length === 0" class="no-data-msg">
      <p>No data sections available for this function.</p>
    </div>
  </div>

  <!-- Dialog Footer -->
  <div class="dialog-footer">
    <div class="footer-left">
      <mat-checkbox 
        [checked]="selectAllChecked" 
        [indeterminate]="selectAllIndeterminate"
        (change)="onSelectAllChange($event.checked)"
        class="select-all-checkbox">
        Select All
      </mat-checkbox>

      <button type="button" class="btn-clear-all" (click)="onClearAll()">
        <mat-icon class="clear-icon">cancel</mat-icon> Clear All
      </button>
    </div>

    <div class="footer-right">
      <button type="button" class="btn-cancel" (click)="onCancel()" [disabled]="isSaving">
        Cancel
      </button>
      <button type="button" class="btn-save" (click)="onSave()" [disabled]="isSaving || isLoading">
        {{ isSaving ? 'Saving...' : 'Save Permissions' }}
      </button>
    </div>
  </div>
</div>
